<div class="ai-conversation-navigation" [class.is-compact]="compact" [class.is-collapsed]="collapsed" (scroll)="onScroll($event)">
  <button class="ai-new btn btn-primary" type="button" (click)="start()" *ngIf="compact">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 5l0 14"/><path d="M5 12l14 0"/></svg>
    <span>New conversation</span>
  </button>

  <ng-container *ngIf="state.pinnedConversations().length">
    <div class="ai-section-label">Pinned</div>
    <ng-container *ngFor="let conversation of state.pinnedConversations()">
      <ng-container *ngTemplateOutlet="conversationRow; context: { $implicit: conversation }"></ng-container>
    </ng-container>
  </ng-container>

  <div class="ai-section-heading" *ngIf="state.groups().length || !collapsed">
    <span class="ai-section-label">Projects</span>
    <button class="btn btn-icon btn-ghost-secondary ai-add-project" type="button" aria-label="Add project" title="Add project" (click)="addProject($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 5l0 14"/><path d="M5 12l14 0"/></svg>
    </button>
  </div>
  <section class="ai-project" *ngFor="let group of state.groups()">
    <div class="ai-project-name"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 7h5l2 2h11v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"/><path d="M3 7v-2a2 2 0 0 1 2 -2h3l2 2h4"/></svg><span>{{ group.name }}</span></div>
    <ng-container *ngFor="let conversation of state.groupConversations()[group.id] || []">
      <ng-container *ngTemplateOutlet="conversationRow; context: { $implicit: conversation }"></ng-container>
    </ng-container>
  </section>

  <div class="ai-section-label">Recents</div>
  <ng-container *ngFor="let conversation of state.recentConversations()">
    <ng-container *ngTemplateOutlet="conversationRow; context: { $implicit: conversation }"></ng-container>
  </ng-container>
  <div class="ai-empty-recents text-secondary small" *ngIf="state.conversations().length === 0 && !collapsed">No previous chats</div>
  <div class="ai-loading-recents" *ngIf="state.loadingMoreRecent()"><span class="spinner-border spinner-border-sm"></span></div>
</div>

<ng-template #conversationRow let-conversation>
  <div class="ai-recent" [class.active]="state.activeConversationId() === conversation.id" [title]="collapsed ? conversation.title : ''">
    <button class="ai-recent-main btn" type="button" [disabled]="conversation.pending" (click)="select(conversation.id)">
      <span class="ai-recent-title">{{ conversation.title }}</span>
      <span class="ai-recent-status ms-1" aria-hidden="true" *ngIf="state.isConversationRunning(conversation) ||  state.isConversationUnread(conversation)">
        <span class="spinner-border spinner-border-sm" *ngIf="state.isConversationRunning(conversation)"></span>
        <span class="ai-unread-dot" *ngIf="!state.isConversationRunning(conversation) && state.isConversationUnread(conversation)"></span>
      </span>
    </button>
    <div class="ai-recent-drawer" [class.menu-open]="openMenuId === conversation.id">
      <span class="ai-recent-date" aria-hidden="true">{{ conversation.updated_at | relativeDate }}</span>
      <button class="ai-recent-menu-trigger btn btn-icon" type="button" aria-label="Conversation actions" [attr.aria-expanded]="openMenuId === conversation.id" (click)="toggleMenu($event, conversation.id)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-dots"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M18 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /></svg>
      </button>
      <div class="dropdown-menu show ai-recent-menu" *ngIf="openMenuId === conversation.id" (click)="$event.stopPropagation()">
        <button class="dropdown-item" type="button" (click)="rename($event, conversation)">Rename</button>
        <button class="dropdown-item" type="button" (click)="pin($event, conversation)">{{ conversation.pinned_at ? 'Unpin' : 'Pin chat' }}</button>
        <div class="dropdown-divider"></div>
        <div class="dropdown-header">Move to project</div>
        <button class="dropdown-item" type="button" *ngFor="let group of state.groups()" (click)="move($event, conversation, group.id)">{{ group.name }}</button>
        <button class="dropdown-item" type="button" *ngIf="conversation.group_id" (click)="move($event, conversation, null)">Remove from project</button>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item text-danger" type="button" (click)="remove($event, conversation)">Delete</button>
      </div>
    </div>
  </div>
</ng-template>

<div class="ai-dialog-backdrop" *ngIf="dialog" (click)="closeDialog()"></div>
<div class="modal modal-blur show d-block ai-conversation-modal" *ngIf="dialog" tabindex="-1"
  role="dialog" aria-modal="true" aria-labelledby="ai-conversation-dialog-title"
  (keydown.escape)="closeDialog()">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form class="modal-content" (ngSubmit)="submitDialog()">
      <div class="modal-header">
        <h3 id="ai-conversation-dialog-title" class="modal-title">
          {{ dialog === 'create-project' ? 'Create project' : dialog === 'rename-chat' ? 'Rename chat' : 'Delete chat' }}
        </h3>
        <button type="button" class="btn-close" aria-label="Close" [disabled]="dialogSaving"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body" *ngIf="dialog === 'create-project' || dialog === 'rename-chat'">
        <label class="form-label" for="ai-conversation-dialog-value">
          {{ dialog === 'create-project' ? 'Project name' : 'Chat name' }}
        </label>
        <input id="ai-conversation-dialog-value" class="form-control" type="text" name="dialogValue"
          [(ngModel)]="dialogValue" [maxlength]="120" required autofocus
          [placeholder]="dialog === 'create-project' ? 'Enter a project name' : 'Enter a chat name'" />
      </div>
      <div class="modal-body" *ngIf="dialog === 'delete-chat'">
        Delete “{{ dialogConversation?.title }}”? This chat will be permanently removed.
      </div>
      <div class="modal-body pt-0" *ngIf="dialogError">
        <div class="alert alert-danger mb-0" role="alert">{{ dialogError }}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" [disabled]="dialogSaving" (click)="closeDialog()">Cancel</button>
        <button *ngIf="dialog !== 'delete-chat'" type="submit" class="btn btn-primary"
          [disabled]="dialogSaving || !dialogValue.trim()">
          {{ dialogSaving ? 'Saving…' : dialog === 'create-project' ? 'Create project' : 'Save changes' }}
        </button>
        <button *ngIf="dialog === 'delete-chat'" type="submit" class="btn btn-danger" [disabled]="dialogSaving">
          {{ dialogSaving ? 'Deleting…' : 'Delete chat' }}
        </button>
      </div>
    </form>
  </div>
</div>
